import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});
//TODO: Add error handling

function addErrorCallback(callback) {
  api.interceptors.response.use(undefined, error => {
    if (error.response) {
      const status = error.response.status;
      const method = error.response.config.method;
      if (status >= 500 || status === 409 || method === 'get') callback(error);
    } else if (!axios.isCancel(error)) {
      // network error + don't show error for canceled requests
      callback(error);
    }

    return Promise.reject(error);
  });
}

function setupResponseInterceptors(responseInterceptors) {
  api.interceptors.response.use(
    response => {
      Object.keys(responseInterceptors).forEach(key => {
        const fn = responseInterceptors[key];
        const headerValue = response.headers[key];
        if (headerValue) {
          fn(headerValue.trim());
        }
      });
      return response;
    },
    error => {
      return Promise.reject(error);
    }
  );
}

function setAccessToken(accessToken) {
  api.defaults.headers.common['Authorization'] = accessToken
    ? `Token ${accessToken}`
    : undefined;
}

export { api, addErrorCallback, setupResponseInterceptors, setAccessToken };
